import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@service/auth.service';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-forbidden-notification',
    templateUrl: './forbidden-notification.component.html',
    styleUrls: ['./forbidden-notification.component.scss'],
    standalone: false
})
export class ForbiddenNotificationComponent implements OnInit, OnDestroy {
    showNotificationSubscription: Subscription;
    visible: boolean = false;

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.showNotificationSubscription = this.authService.showNotification$.subscribe(() => {
            this.visible = true;
        });
    }

    ngOnDestroy(): void {
        this.showNotificationSubscription?.unsubscribe();
    }

    closeOverlay() {
        this.visible = false;
    }

    changeAccount(){
      this.authService.signOut();
      this.authService.showSignInOverlay();
      this.visible = false;
    }
}
